import React from 'react'

import { Table } from '../Table'
import FinancialsTableRow from './FinancialsTableRow'
import {
  FinancialsColumnDefinition,
  FinancialsRowDataType,
  FinancialsSubColumnDefinition,
  FinancialsSubRowDataType,
} from './types'

type FinancialsTableProps<
  RowDataType extends FinancialsRowDataType,
  ColumnDefinition extends FinancialsColumnDefinition<RowDataType>,
  SubColumnDefinition extends FinancialsSubRowDataType,
> = {
  tableHead?: React.ReactNode
  tableFooter?: React.ReactNode
  data: RowDataType[]
  columns: ColumnDefinition[]
  subColumns: Record<string, FinancialsSubColumnDefinition<SubColumnDefinition>[]>
  onVisibilityChange: (area: string, visibility: boolean) => void
}

export default function FinancialsTable<
  RowDataType extends FinancialsRowDataType,
  ColumnDefinition extends FinancialsColumnDefinition<RowDataType>,
  SubColumnDefinition extends FinancialsSubRowDataType,
>({
  tableHead,
  tableFooter,
  columns,
  subColumns,
  data,
  onVisibilityChange,
}: FinancialsTableProps<RowDataType, ColumnDefinition, SubColumnDefinition>) {
  return (
    <Table className="financials-table table-fixed leading-4 [overflow-anchor:none]">
      {tableHead}
      {data.map((row, index) => (
        <FinancialsTableRow
          key={row.label}
          data={row}
          columns={columns}
          subColumns={subColumns}
          onVisibilityChange={onVisibilityChange}
          isFirst={index === 0}
          isLast={index === data.length - 1}
        />
      ))}
      {tableFooter}
    </Table>
  )
}
